/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';

export class antenatalattendancestat extends IceEntity {
  antenatal_total: number = 0;
  antenatal_first_visit_before_14weeks: number = 0;
  antenatal_first_visit_before_20weeks: number = 0;
  antenatal_first_20_weeks_or_later: number = 0;
  antenatal_first_28_weeks_or_later: number = 0;
  antenatal_first_visit_total: number = 0;
  anc_syphilis_test: number = 0;
  anc_syphilis_positive: number = 0;
  received_malaria_ipt1: number = 0;
  received_malaria_ipt2: number = 0;
  received_malaria_ipt3: number = 0;
  received_hematinics: number = 0;
  postnatal_attendance_total: number = 0;
  postnatal_epds_administered_total: number = 0;
  postnatal_epds_depression_criteria_total: number = 0;
  postnatal_epds_riskofhurting_criteria_total: number = 0;

  public gettablename(): string {
    return "ANTENATAL_ATTENDANCE_STAT";
  }
}
